import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import API from '../../services/api';
import Card from '../../components/common/Card';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';
import './LoginClient.css';

const LoginClient = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [successMessage, setSuccessMessage] = useState(location.state?.message || '');

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => setSuccessMessage(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: null });
    }
    if (apiError) setApiError('');
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = "Email requis";
    if (!formData.password) newErrors.password = "Mot de passe requis";
    return newErrors;
  };

  // LIGNE 54 - Remplacer cette partie
const handleSubmit = async (e) => {
  e.preventDefault();
  
  const validationErrors = validate();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }

  setLoading(true);
  try {
   
    const res = await API.post('/auth/client/login', formData);
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    localStorage.setItem('userType', 'client');
    navigate('/dashboard/client');
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Email ou mot de passe incorrect';
    setApiError(errorMsg);
  } finally {
    setLoading(false);
  }
};
  return (
    <div className="page-container">
      <div className="container" style={{ maxWidth: '450px' }}>
        <Card padding="2.5rem">
          <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '0.5rem', textAlign: 'center' }}>
            Connexion client
          </h1>
          <p style={{ textAlign: 'center', color: '#6B7A8F', marginBottom: '2rem' }}>
            Accédez à votre espace personnel
          </p>

          {successMessage && <Alert type="success" message={successMessage} />}
          {apiError && <Alert type="error" message={apiError} />}

          <form onSubmit={handleSubmit}>
            <Input
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              error={errors.email}
              required
              autoComplete="email"
            />
            
            <Input
              label="Mot de passe"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              error={errors.password}
              required
              autoComplete="current-password"
            />
            
            <Button type="submit" variant="primary" fullWidth disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '2rem', color: '#6B7A8F' }}>
            Pas encore de compte ?{' '}
            <Link to="/register/client" style={{ color: '#0066FF', textDecoration: 'none', fontWeight: '500' }}>
              Inscrivez-vous
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
};

export default LoginClient;